import React from 'react';
import { gql, useQuery } from '@apollo/client';
import type { GetGeneralSettingsQuery, GetGeneralSettingsQueryVariables } from '../../types/gql-backend';
import Header from '../Header/index';
import BreadCrumb from 'components/BreadCrumb/index.js';
import PluginVersionEdit from './components/PluginVersionEdit';

const GET_GENERAL_SETTINGS = gql`
  query GetGeneralSettings {
    generalSettings {
      pluginVersion
      DEPLOYMENT_ENVIRONMENT
    }
  }
`;

export default function GeneralSettingsView() {
  const { data, loading, error } = useQuery<GetGeneralSettingsQuery, GetGeneralSettingsQueryVariables>(GET_GENERAL_SETTINGS);
  //TODO: Implement Loading State without Saga
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <>
      <Header key="GeneralSettings-Header-Element">
        {/*
        //TODO: Implement NotificationEngine without Saga
         <NotificationEngine />
         */}
        <nav className="bg-white border border-secondary border-top-0 border-left-0 border-right-0 py-3">
          <div className="container">
            <div className="row">
              <div className="col-10 align-self-end">
                <BreadCrumb path={[{ label: 'GENERAL SETTINGS' }]} />
                <h1 className="h4 m-0">General Settings</h1>
              </div>
            </div>
          </div>
        </nav>
      </Header>
      {data && (
        <PluginVersionEdit data={data} />
      )}
    </>
  );
}
